<template>
  <div class="control has-icons-right">
    <input
      :id="id"
      class="input is-text"
      type="text"
      :placeholder="placeholder"
      :maxlength="maxLength"
      v-on:input="valueChanged"
      @keypress="isNumber($event)"
      :required="isRequired"
    />
    <span class="icon is-right has-text-right" style="z-index:0">
      <p
        class="is-size-7 is-large mr-1 ml-1"
        :class="{ 'has-red-text': curLength == maxLength }"
      >
        {{ curLength }}/{{ maxLength }}
      </p>
    </span>
  </div>
</template>

<script>
export default {
  props: {
      id:{
          type:String,
          required: true
      },
    placeholder: {
      type: String,
      required: false,
    },
    maxLength: {
      type: Number,
      required: true,
    },
    isNumberOnly:{
        type:Boolean,
        default: false
    },
    isRequired:{
        type:Boolean,
        default: false
    }
  },
  data() {
    return {
      curLength: 0,
    };
  },
  methods: {
    valueChanged() {
      this.$emit("valChanged");

        //console.log(document.getElementById(this.id).value);
      this.curLength = document.getElementById(this.id).value.length;
    },
    setValue(v) {
      var obj = document.getElementById(this.id);
      obj.value = v;
      this.curLength = obj.value.length;
    },
    getValue() {
      return document.getElementById(this.id).value;
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      if(this.isNumberOnly){
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (
            charCode > 31 &&
            (charCode < 48 || charCode > 57) &&
            charCode !== 46
        ) {
            evt.preventDefault();
        } else {
            return true;
        }
      }
      else return;
    },
  },
};
</script>